import { createI18n } from 'vue-i18n';
import SelectOption, { SelectOptionWithData } from './models/SelectOption';
import _ from 'lodash';
import enUS from '@/lang/en-US.json';

const i18n = createI18n<[typeof enUS], 'en-US' | 'ru-RU' | 'en-US'>({
    locale: 'en-US',
    legacy: false,
    globalInjection: true,
    fallbackLocale: 'en-US',
    messages: {
        'en-US': enUS,
    } as any,
});

export default i18n;

export const tbase = (base: string, keyword: string): string => {
    const key = [base, keyword].join('.').toLowerCase();
    return i18n.global.te(key) ? (i18n.global.t(key) as string) : keyword;
};

export function translateListWithData<T>(list: SelectOptionWithData<T>[], baseKeyword?: string): SelectOptionWithData<T>[] {
    const base = baseKeyword + '.';
    let getT = (x: SelectOption) => i18n.global.t(x.text) as string;
    if (baseKeyword) getT = (x) => tbase(base, x.text);
    return list.map((x) => {
        const n = _.clone(x);
        n.text = getT(x);
        return n;
    });
}

export function translateListPrefix(list: SelectOption[], baseKeyword: string): SelectOption[] {
    let getT = (x: SelectOption) => i18n.global.t(baseKeyword + '.' + x.text) as string;
    return list.map((x) => {
        const n = _.clone(x);
        n.text = getT(x);
        return n;
    });
}

export function translateList(list: SelectOption[], baseKeyword?: string): SelectOption[] {
    const base = baseKeyword + '.';
    let getT = (x: SelectOption) => i18n.global.t(x.text) as string;
    if (baseKeyword) getT = (x) => tbase(base, x.text);
    return list.map((x) => {
        const n = _.clone(x);
        n.text = getT(x);
        return n;
    });
}

export const locales = [
    {
        name: 'he-IL',
        text: 'עִברִית',
        dir: 'rtl',
        twoLetter: 'he',
        image: 'img/israel.svg',
    },
    {
        name: 'ru-RU',
        text: 'Русский',
        dir: 'ltr',
        twoLetter: 'ru',
        image: 'img/russia.svg',
    },
    {
        name: 'en-US',
        text: 'English',
        dir: 'ltr',
        twoLetter: 'en',
        image: 'img/usa.svg',
    },
];
